export const NABE = { name: 'Watanabe Hisashi',
    role: 'Analyst & Student Coach | 3rd year | Kanagawa Prefecture',
    details: '',
    edu: 'Management, School of Commerce, Meiji University | Seidou High School ',
    affiliation: 'Tokyo Six University Baseball Federation',
    photo:'/Nabe.JPG'
}

export const NAO = { name: 'Matsubara Nao',
    role: 'Analyst & Student Coach | 3rd year | Tokyo',
    details: '',
    edu: 'Data Science, Applied Mathematics, Meiji University | Ugumori High School',
    affiliation: 'Tokyo Six University Baseball Federation',
    photo:'/Nao.jpg'
}

export const ADACHI = { name: 'Adachi Mi',
    role: 'Manager | 4th year | Iwate',
    details: '',
    edu: 'Clinical Psychology, School of Arts and Letters, Meiji University | Iwate High School ',
    affiliation: 'Tokyo Six University Baseball Federation',
    photo:'/Adachi.png'
}

export const AKEMI = { name: 'Sato Akemi',
    role: 'Manager | 3rd year | Miyagi Prefecture',
    details: '',
    edu: 'Literature, School of Arts and Letters, Meiji University | Iwate High School ',
    affiliation: 'Tokyo Six University Baseball Federation',
    photo:'/Sato.png'
}

export const ASAHI = { name: 'Asahi Sadao',
    role: 'Manager | 4th year | Tokyo',
    details: '',
    edu: 'Business Law, School of Law, Meiji University | Meiji Nakano High School ',
    affiliation: 'Tokyo Six University Baseball Federation',
    photo:'/Asahi.png'
}

export const UENO = { name: 'Ueno Ken',
    role: 'Chief Manager | 4th year | Kanazawa Prefecture',
    details: '',
    edu: 'School of Business Administration, Meiji University | Seiryo High School ',
    affiliation: 'Tokyo Six University Baseball Federation',
    photo:'/Ueno.png'
}

export const NII = { name: 'Nii Michi',
    role: 'Analyst & Student Coach | 1st year | Sendai',
    details: '',
    edu: 'Information Science, Engineering, Meiji University | Sendai Ikuei Gakuen High School ',
    affiliation: 'Tokyo Six University Baseball Federation',
    photo:'/Nii.png'
}

export const NASHITA = { name: 'Nashita Daichi',
    role: 'Manager | 2nd year | Osaka Prefecture',
    details: 'Throws Right, Bats Left/Right',
    edu: 'Creative Business, School of Commerce, Meiji University | Riseisha High School ',
    affiliation: 'Tokyo Six University Baseball Federation',
    photo:'/Nashita.png'
}
